module.exports = "../images/fishing-lodge-23.jpg?v=422d6c5";